import React, { PropTypes } from 'react';
import { Link } from 'react-router';
import classNames from 'classnames';
import { findPrevNextFromUri, trUri } from '../utils';

const isBrowser = typeof window !== 'undefined';
const WOW = (isBrowser) ? require('wow.js') : undefined;

class SiteNavigation extends React.Component {
  constructor(props) {
    super(props);
    this.state = { overPrev: false, overNext: false };
    if (isBrowser) {
      const wow = new WOW(
        {
          boxClass: 'wow',      // animated element css class (default is wow)
          animateClass: 'animated', // animation css class (default is animated)
          offset: 0, // distance to the element when triggering the animation (default is 0)
          mobile: true,       // trigger animations on mobile devices (default is true)
          live: true,       // act on asynchronously loaded content (default is true)
          scrollContainer: 'section', // optional scroll container selector, otherwise use window
        }
      );
      wow.init();
    }
  }

  mouseOverPrev() {
    this.setState({ overPrev: true });
  }

  mouseOverNext() {
    this.setState({ overNext: true });
  }

  render() {
    const { lang, items, currentNormalizedPath } = this.props;
    const [p, n] = findPrevNextFromUri(items, currentNormalizedPath, lang, true);
    return (
      <div className="navlinkContainer">
        {p && <Link
          className={classNames(
            'navigationlink',
            'prev', 'wow', 'fadeInLeft',
            'animated', { finish: this.state.overPrev })}
          onMouseOver={() => this.mouseOverPrev}
          to={`/${lang}${trUri(p, lang, '/')}`}
        >{p.getIn(['title', lang], p.get('title', '-----'))}
          <span className="underlink"></span>
        </Link>}
        {n && <Link
          className={classNames(
            'navigationlink',
            'next', 'wow', 'fadeInRight',
            'animated', { finish: this.state.overNext })}
          onMouseOver={() => this.mouseOverNext}
          to={`/${lang}${trUri(n, lang, '/')}`}
        >{n.getIn(['title', lang], n.get('title', '-----'))}
          <span className="underlink"></span>
        </Link>}
      </div>);
  }
}

SiteNavigation.propTypes = {
  lang: PropTypes.string.isRequired,
  items: PropTypes.object.isRequired,
  currentNormalizedPath: PropTypes.string.isRequired,
};

export default SiteNavigation;



// WEBPACK FOOTER //
// ./common/components/SiteNavigation.js